import React from 'react';
import { useTranslation } from 'react-i18next';
import Divider from 'components/Divider/Divider';
import { BoldSubtitle, Title } from 'components/Text';
import useStyles from './PassingListStyles';
import PassingRow from './PassingRow';
import { useRecoilState } from 'recoil';
import { showCheckboxColumn } from 'api/passings/getFilteredPassings';
export default function PassingList({
  items
}) {
  const {
    t
  } = useTranslation();
  const {
    passings,
    column
  } = useStyles();
  const [showCheckbox, setShowCheckbox] = useRecoilState(showCheckboxColumn);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: passings
  }, showCheckbox && /*#__PURE__*/React.createElement("div", {
    className: column
  }, /*#__PURE__*/React.createElement(BoldSubtitle, null, "Export")), /*#__PURE__*/React.createElement("div", {
    className: column
  }, /*#__PURE__*/React.createElement(BoldSubtitle, null, t('passings.vehicle')), /*#__PURE__*/React.createElement(BoldSubtitle, null, t('passings.identification'))), /*#__PURE__*/React.createElement("div", {
    className: column
  }, /*#__PURE__*/React.createElement(BoldSubtitle, null, t('passings.time'))), /*#__PURE__*/React.createElement("div", {
    className: column
  }, /*#__PURE__*/React.createElement(BoldSubtitle, null, t('passings.checkpoint'))), /*#__PURE__*/React.createElement("div", {
    className: column
  }, /*#__PURE__*/React.createElement(BoldSubtitle, null, t('passings.price')))), items?.map(item => /*#__PURE__*/React.createElement("div", {
    key: item.id
  }, /*#__PURE__*/React.createElement(PassingRow, item), /*#__PURE__*/React.createElement(Divider, null))), !items.length && /*#__PURE__*/React.createElement(Title, {
    align: "center"
  }, t('passings.no_passings')));
}